export const GET_POLYGON_LAYER = 'GET_POLYGON_LAYER';
export const GET_POLYGON_SUCCESS = 'GET_POLYGON_SUCCESS';
export const GET_POLYGON_FAILURE = 'GET_POLYGON_FAILURE';
export const GET_TRAFFIC_LAYER = 'GET_TRAFFIC_LAYER';
export const GET_TRAFFIC_SUCCESS = 'GET_TRAFFIC_SUCCESS';
export const GET_TRAFFIC_FAILURE = 'GET_TRAFFIC_FAILURE';
export const GET_CONFIG = 'GET_CONFIG';
export const GET_LINK_DESC = 'GET_LINK_DESC';
export const GET_LINK_INFO = 'GET_LINK_INFO';
export const GET_AVAILABLE_DATA_FEEDS = 'GET_AVAILABLE_DATA_FEEDS';
export const GET_AVAILABLE_DATA_FEEDS_SUCCESS =
  'GET_AVAILABLE_DATA_FEEDS_SUCCESS';
export const GET_AVAILABLE_DATA_FEEDS_FAILURE =
  'GET_AVAILABLE_DATA_FEEDS_FAILURE';
export const GET_SUBSCRIBED_DATA_FEEDS = 'GET_SUBSCRIBED_DATA_FEEDS';
export const GET_SUBSCRIBED_DATA_FEEDS_SUCCESS =
  'GET_SUBSCRIBED_DATA_FEEDS_SUCCESS';
export const GET_SUBSCRIBED_DATA_FEEDS_FAILURE =
  'GET_SUBSCRIBED_DATA_FEEDS_FAILURE';
export const GET_LINK_LOCATION_DETAILS = 'GET_LINL_LOCATION_DETAILS';
export const GET_ALERT_EVENTS = 'GET_ALERT_EVENTS';
export const GET_ALERT_EVENTS_SUCCESS = 'GET_ALERT_EVENTS_SUCCESS';
export const GET_ALERT_EVENTS_FAILURE = 'GET_ALERT_EVENTS_FAILURE';
export const GET_DATA_FEED_FORM_CHANGE = 'GET_DATA_FEED_FORM_CHANGE';
export const GET_DATA_FEEDS_STATUS_SUCCESS = 'GET_DATA_FEEDS_STATUS_SUCCESS';
export const GET_DATA_FEEDS_STATUS_FAILURE = 'GET__DATA_FEEDS_STATUS_FAILURE';
export const GET_CURRENT_ALERT_EVENTS = 'GET_CURRENT_ALERT_EVENTS';
export const GET_CURRENT_ALERT_EVENTS_SUCCESS =
  'GET_CURRENT_ALERT_EVENTS_SUCCESS';
export const GET_CURRENT_ALERT_EVENTS_FAILURE =
  'GET_CURRENT_ALERT_EVENTS_FAILURE';
export const GET_CURRENT_ALERT_EVENTS_RESET = 'GET_CURRENT_ALERT_EVENTS_RESET';
export const GET_DISABLED_ALL_DATA_FEEDS = 'GET_DISABLED_ALL_DATA_FEEDS';
export const GET_DISABLED_ALL_DATA_FEEDS_SUCCESS =
  'GET_DISABLED_ALL_DATA_FEEDS_SUCCESS';
export const GET_DISABLED_ALL_DATA_FEEDS_FAILURE =
  'GET_DISABLED_ALL_DATA_FEEDS_FAILURE';
export const GET_UPDATED_DATA_FEEDS = 'GET_UPDATED_DATA_FEEDS';
export const GET_UPDATED_DATA_FEEDS_SUCCESS = 'GET_UPDATED_DATA_FEEDS_SUCCESS';
export const GET_UPDATED_DATA_FEEDS_FAILURE = 'GET_UPDATED_DATA_FEEDS_FAILURE';
export const CLEAR_CURRENT_EVENT_DATA = 'CLEAR_CURRENT_EVENT_DATA';
export const CLEAR_LINK_LOCATION_DATA = 'CLEAR_LINK_LOCATION_DATA';
export const SET_SIGNALR_GROUPS = 'SET_SIGNALR_GROUPS';
